import { render, staticRenderFns } from "./RegionalBiddingChart.vue?vue&type=template&id=6912134a&scoped=true&"
import script from "./RegionalBiddingChart.vue?vue&type=script&lang=js&"
export * from "./RegionalBiddingChart.vue?vue&type=script&lang=js&"
import style0 from "./RegionalBiddingChart.vue?vue&type=style&index=0&id=6912134a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912134a",
  null
  
)

export default component.exports